import '@/modules/global';
import { Header, StickyHeader } from '@/modules/header';
import PredictiveSearch from '@/modules/predictive-search';
import CartNotification from '@/modules/cart-notification';
import ResponsiveVideo from '@/modules/responsive-video';
import LazyVideo from '@/modules/lazy-video';
import FeaturedCollectionsSlider from '@/modules/featured-collections';
import MediaGridSlider from '@/modules/media-grid';
import ProductCarousel from '@/modules/product-carousel';
import PortraitVideoSwiper from '@/modules/portrait-video-swiper';
import ProductCarouselArticle from '@/modules/product-carousel-article';
import NewsCarousel from '@/modules/news-carousel';
import NewsCarouselArticle from '@/modules/news-carousel-article';
import HalfWidthCarousel from '@/modules/half-width-carousel';
import MediaCarousel from '@/modules/media-carousel';
import LogoGrid from '@/modules/logo-grid';
import SquareMediaContentGrid from '@/modules/square-media-content-grid';
import FeaturedIconCarousel from '@/modules/featured-icon-carousel';
import { StatsCarouselAnimation, StatsCarouselCarousel } from '@/modules/stats-carousel';
import { FeaturedProductListContentSwap } from '@/modules/featured-product-list';
import { BeforeAndAfterCarousel, BeforeAndAfterToggle } from '@/modules/before-and-after';
import { Ticker } from '@/modules/ticker';
import { MediaScale } from '@/modules/animation';
import TabbedMediaContent from '@/modules/tabbed-media-content';
import AnnouncementCarousel from '@/modules/announcement-carousel';
import CartCrossSellCarousel from '@/modules/cart-cross-sell-carousel';

import '@/modules/accordion';
import KeyboardFocus from '@/modules/keyboard-focus/keyboard-focus';

const responsiveVideos = document.querySelectorAll('.js-responsive-video');
if (responsiveVideos) {
    Array.from(responsiveVideos).forEach(el => new ResponsiveVideo(el));
}

const lazyVideos = document.querySelectorAll('.js-lazy-video');
if (lazyVideos) {
    new LazyVideo(lazyVideos);
}

new Header();

if (document.getElementsByTagName('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
}

if (document.getElementsByTagName('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}

if (document.getElementsByTagName('cart-notification')) {
    customElements.define('cart-notification', CartNotification);
}

const collectionSliders = document.querySelectorAll('.js-featured-collections-slider');
if (collectionSliders) {
    collectionSliders.forEach(el => new FeaturedCollectionsSlider(el));
}

const mediaGridSliders = document.querySelectorAll('.js-media-grid-slider');
if (mediaGridSliders) {
    mediaGridSliders.forEach(el => new MediaGridSlider(el));
}

const productSliders = document.querySelectorAll('.js-product-carousel');
if (productSliders) {
    productSliders.forEach(el => new ProductCarousel(el));
}

const portraitVideoSwiper = document.querySelectorAll('.js-portrait-video-carousel');
if (portraitVideoSwiper) {
    portraitVideoSwiper.forEach(el => new PortraitVideoSwiper(el));
}

const productArticleSliders = [...document.querySelectorAll('.js-product-carousel-article')];
if (productArticleSliders.length) {
    productArticleSliders.forEach(el => new ProductCarouselArticle(el));
}

const newsSliders = document.querySelectorAll('.js-news-carousel');
if (newsSliders) {
    newsSliders.forEach(el => new NewsCarousel(el));
}

const newsArticleSliders = [...document.querySelectorAll('.js-news-carousel-article')];
if (newsArticleSliders) {
    newsArticleSliders.forEach(el => new NewsCarouselArticle(el));
}

const halfWidthCarousel = document.querySelectorAll('.js-half-width-carousel');
if (halfWidthCarousel) {
    halfWidthCarousel.forEach(el => new HalfWidthCarousel(el));
}

const mediaCarousel = document.querySelectorAll('.js-media-carousel');
if (mediaCarousel) {
    mediaCarousel.forEach(el => new MediaCarousel(el));
}

const logoGrid = document.querySelectorAll('.js-logo-grid');
if (logoGrid) {
    logoGrid.forEach(el => new LogoGrid(el));
}

const squareMediaContentGrid = document.querySelectorAll('.js-square-media-content-grid');
if (squareMediaContentGrid) {
    squareMediaContentGrid.forEach(el => new SquareMediaContentGrid(el));
}

const featuredIconsSliders = document.querySelectorAll('.js-featured-icons-carousel');
if (featuredIconsSliders) {
    featuredIconsSliders.forEach(el => new FeaturedIconCarousel(el));
}

const statsCarouselAnimations = [...document.querySelectorAll('.js-stats-carousel-animation')];
if (statsCarouselAnimations.length) {
    statsCarouselAnimations.forEach(item => new StatsCarouselAnimation(item));
}

const statsCarouselCarousels = [...document.querySelectorAll('.js-stats-carousel-carousel')];
if (statsCarouselCarousels.length) {
    statsCarouselCarousels.forEach(item => new StatsCarouselCarousel(item));
}

const featuredProductListContentSwaps = [...document.querySelectorAll('.js-featured-product-list-content-swap')];
if (featuredProductListContentSwaps.length) {
    featuredProductListContentSwaps.forEach(el => new FeaturedProductListContentSwap(el));
}

const tabbedContentCarousels = document.querySelectorAll('.js-tabbed-media-content');
if (tabbedContentCarousels) {
    tabbedContentCarousels.forEach(el => new TabbedMediaContent(el));
}

const announcementCarousels = document.querySelectorAll('.js-announcement-carousel');
if (announcementCarousels) {
    announcementCarousels.forEach(el => new AnnouncementCarousel(el));
}

if ([...document.querySelectorAll('.js-before-and-after-carousel')].length) {
    [...document.querySelectorAll('.js-before-and-after-carousel')].forEach(item => new BeforeAndAfterCarousel(item));
}

if ([...document.querySelectorAll('.js-before-and-after-toggle')].length) {
    [...document.querySelectorAll('.js-before-and-after-toggle')].forEach(item => new BeforeAndAfterToggle(item));
}

const tickers = [...document.querySelectorAll('.js-ticker')];
if (tickers.length) {
    tickers.forEach(el => new Ticker(el));
}

const cartCrossSellCarousels = document.querySelectorAll('.js-cart-cross-sell-carousel');
if (cartCrossSellCarousels.length) {
    cartCrossSellCarousels.forEach(el => new CartCrossSellCarousel(el));
}

new KeyboardFocus();
new MediaScale();
